export default __webpack_public_path__ + "static/media/easy.d8c4d0a3.svg";